import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MetricsDashboardDocumentUnloaderGuard implements CanActivate {
    constructor(private store: Store, private route: ActivatedRoute){}
    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let canActivate = true;
        
        return canActivate;
    }
}